import { createTheme } from "@mui/material";
import type {} from "@mui/x-data-grid/themeAugmentation";
import { grey } from "@mui/material/colors";

export const getTheme = () => {
  return createTheme({
    colorSchemes: {
      light: {
        palette: {
          primary: {
            main: "#1976d2",
            contrastText: "#FAF9F6",
          },
          secondary: {
            main: "#E0C2FF",
            light: "#F5EBFF",
            contrastText: "#47008F",
          },
          background: {
            default: grey[100],
            paper: "#FAF9F6",
          },
          text: {
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.6)",
          },
        },
      },
      dark: {
        palette: {
          primary: {
            main: "#003A61",
            dark: "#003356",
            light: "#00406C",
            contrastText: "#FAF9F6",
          },
          secondary: {
            main: "#002137",
            light: "#00253E",
            contrastText: "#FAF9F6",
          },
          background: {
            default: "#00111C",
            paper: "#001523",
          },
          text: {
            primary: "#FAF9F6",
            secondary: "rgba(255, 255, 255, 0.7)",
          },
        },
      },
    },
    typography: {
      fontFamily: "Poppins",
      body1: {
        fontSize: 14,
      },
    },
    shape: {
      borderRadius: "6px",
    },
    shadows: [
      "none",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
      "0px 2px 4px rgb(0, 0, 0, 0.1)",
    ],
    components: {
      MuiTextField: {
        defaultProps: {
          size: "small",
        },
        styleOverrides: {
          root: ({ theme }) => ({
            "&:hover": {
              transition: theme.transitions.create(["border-color"], {
                duration: "10s",
              }),
            },
          }),
        },
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: ({ theme }) => ({
            textTransform: "none",
            backgroundColor: "transparent",
            color: theme.palette.text.secondary,
            borderColor: theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
              color: theme.palette.text.primary,
            },
          }),
        },
        variants: [
          {
            props: { variant: "navigation" },
            style: ({ theme }) => ({
              backgroundColor: "transparent",
              color: theme.palette.text.secondary,
              border: "none",
              padding: "8px 16px",
              borderRadius: theme.shape.borderRadius,
              transition: theme.transitions.create(
                ["background-color", "color"],
                {
                  duration: theme.transitions.duration.short,
                }
              ),
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
                color: theme.palette.text.primary,
              },
            }),
          },
          {
            props: { variant: "contained" },
            style: ({ theme }) => ({
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
            }),
          },
        ],
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            height: "2px",
            maxWidth: "65%",
            margin: "auto",
          },
        },
      },
    },
  });
};

declare module "@mui/material/Button" {
  // eslint-disable-next-line
  interface ButtonPropsVariantOverrides {
    navigation: true;
  }
}
